import { Console } from '../console/Console';
import { useBotOutlet } from '../botOutlet';

/** Renter entry point into the same Console (§7.3). Only the gating differs. */
export function RenterConsoleRoute() {
  const { bot, caps, reload, rental } = useBotOutlet();
  return <Console bot={bot} caps={caps} reload={reload} scope="renter" rental={rental} />;
}
